/* Firework Superstore — theme.js
   Lightweight vanilla JS. No frameworks, no build step. */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var routes = window.FWS && window.FWS.routes ? window.FWS.routes : { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart' };
  var strings = window.FWS && window.FWS.strings ? window.FWS.strings : {};

  /* ---------- Countdown timers (hero + announcement) ---------- */
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-countdown'));
    if (isNaN(target)) return;
    var dEl = el.querySelector('[data-cd-d]'), hEl = el.querySelector('[data-cd-h]'),
        mEl = el.querySelector('[data-cd-m]'), sEl = el.querySelector('[data-cd-s]');
    function tick() {
      var diff = target - new Date();
      if (diff <= 0) { el.hidden = true; clearInterval(iv); return; }
      if (dEl) dEl.textContent = Math.floor(diff / 864e5);
      if (hEl) hEl.textContent = pad(Math.floor(diff % 864e5 / 36e5));
      if (mEl) mEl.textContent = pad(Math.floor(diff % 36e5 / 6e4));
      if (sEl) sEl.textContent = pad(Math.floor(diff % 6e4 / 1e3));
    }
    tick();
    var iv = setInterval(tick, 1000);
  });

  /* ---------- Dispatch cutoff ("Order in the next 6h 24m") ---------- */
  document.querySelectorAll('[data-cutoff]').forEach(function (el) {
    var parts = (el.getAttribute('data-cutoff') || '16:00').split(':');
    function tick() {
      var now = new Date();
      var cutoff = new Date(now);
      cutoff.setHours(parseInt(parts[0], 10) || 16, parseInt(parts[1], 10) || 0, 0, 0);
      if (cutoff <= now) { el.closest('[data-cutoff-line]') && (el.closest('[data-cutoff-line]').hidden = true); return; }
      var diff = cutoff - now;
      var h = Math.floor(diff / 36e5), m = Math.floor(diff % 36e5 / 6e4);
      el.textContent = h > 0 ? h + 'h ' + m + 'm' : m + 'm';
    }
    tick();
    setInterval(tick, 30000);
  });

  /* ---------- Hero fireworks canvas ---------- */
  (function () {
    var cv = document.querySelector('[data-fireworks]');
    if (!cv || reducedMotion || document.body.classList.contains('no-canvas')) return;
    var cx = cv.getContext('2d');
    var W, H, parts = [], rockets = [], MAX_PARTS = 900;
    var COLORS = ['#FF2E92', '#FF6B35', '#C6FF4D', '#3DD6F5', '#FFD54D', '#FFF9F2'];
    function size() { W = cv.width = cv.offsetWidth; H = cv.height = cv.offsetHeight; }
    size();
    window.addEventListener('resize', size);
    function launch() {
      var x = W * 0.45 + Math.random() * W * 0.5;
      rockets.push({ x: x, y: H + 10, vy: -(5.5 + Math.random() * 3), tx: H * 0.12 + Math.random() * H * 0.4, c: COLORS[Math.floor(Math.random() * COLORS.length)] });
    }
    function burst(x, y, c) {
      var n = 42 + Math.floor(Math.random() * 30);
      if (parts.length + n > MAX_PARTS) return;
      for (var i = 0; i < n; i++) {
        var a = (Math.PI * 2 / n) * i + Math.random() * 0.2, sp = 1.2 + Math.random() * 3.2;
        parts.push({ x: x, y: y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, life: 1, decay: 0.008 + Math.random() * 0.012, c: c, r: 1.2 + Math.random() * 1.6 });
      }
    }
    function frame() {
      cx.clearRect(0, 0, W, H);
      for (var i = rockets.length - 1; i >= 0; i--) {
        var r = rockets[i];
        r.y += r.vy;
        cx.globalAlpha = 0.9; cx.fillStyle = r.c;
        cx.beginPath(); cx.arc(r.x, r.y, 1.8, 0, 7); cx.fill();
        if (r.y <= r.tx) { burst(r.x, r.y, r.c); rockets.splice(i, 1); }
      }
      for (var j = parts.length - 1; j >= 0; j--) {
        var p = parts[j];
        p.x += p.vx; p.y += p.vy;
        p.vy += 0.018; p.vx *= 0.985; p.vy *= 0.985;
        p.life -= p.decay;
        if (p.life <= 0) { parts.splice(j, 1); continue; }
        cx.globalAlpha = Math.max(p.life, 0); cx.fillStyle = p.c;
        cx.beginPath(); cx.arc(p.x, p.y, p.r * p.life, 0, 7); cx.fill();
      }
      cx.globalAlpha = 1;
      requestAnimationFrame(frame);
    }
    frame();
    launch();
    setInterval(function () {
      if (document.hidden) return;
      launch();
      if (Math.random() > 0.55) setTimeout(launch, 500);
    }, 1900);
  })();

  /* ---------- Twinkle sparkles ---------- */
  (function () {
    var hero = document.querySelector('[data-sparkles]');
    if (!hero || reducedMotion) return;
    for (var i = 0; i < 14; i++) {
      var s = document.createElement('span');
      s.className = 'spark';
      s.textContent = '✦';
      s.setAttribute('aria-hidden', 'true');
      s.style.left = (Math.random() * 96) + '%';
      s.style.top = (Math.random() * 85) + '%';
      s.style.fontSize = (6 + Math.random() * 9) + 'px';
      s.style.animationDelay = (Math.random() * 2.4) + 's';
      hero.appendChild(s);
    }
  })();

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var box = btn.closest('.qty');
    var input = box && box.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v += btn.getAttribute('data-qty-change') === 'down' ? -1 : 1;
    var min = parseInt(input.min, 10);
    input.value = Math.max(isNaN(min) ? 1 : min, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart bubble ---------- */
  function setCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (b) {
      b.textContent = n;
      b.setAttribute('data-count', n);
    });
  }

  /* ---------- Free gift over a spend ---------- */
  // The basket decides whether the gift is there, not the customer: it goes in
  // once the spend clears the threshold and comes back out when it drops under.
  // The gift's own price is left out of that sum, so a free gift can never hold
  // the basket above the line on its own.
  var gift = (window.FWS && window.FWS.gift) || null;
  var giftLive = !!(gift && gift.enabled && gift.variant && gift.threshold > 0);

  function giftSpend(cart) {
    var total = 0;
    (cart.items || []).forEach(function (item) {
      if (item.variant_id !== gift.variant) total += item.final_line_price;
    });
    return total;
  }
  function giftHeld(cart) {
    var n = 0;
    (cart.items || []).forEach(function (item) {
      if (item.variant_id === gift.variant) n += item.quantity;
    });
    return n;
  }
  // Resolves true only when the basket really changed, so callers know whether a
  // refresh is worth it — and so an add that fails cannot spin into a loop.
  function reconcileGift(cart) {
    if (!giftLive || !cart) return Promise.resolve(false);
    var held = giftHeld(cart);
    var wanted = giftSpend(cart) >= gift.threshold ? 1 : 0;
    if (held === wanted) return Promise.resolve(false);
    var url, body;
    if (wanted && held === 0) {
      // Nothing there yet, so add it — this is the only path that can attach
      // the marker property that tells the basket page it is the gift.
      url = routes.cart_add_url + '.js';
      body = { items: [{ id: gift.variant, quantity: 1, properties: { _gift: 'yes' } }] };
    } else {
      // Set the exact quantity rather than adding to it. This both removes the
      // gift when the basket drops under the line, and clamps it back to one if
      // somebody found the gift product themselves and piled several in.
      url = routes.cart_url + '/update.js';
      body = { updates: {} };
      body.updates[gift.variant] = wanted;
    }
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }
  function onCartPage() {
    return window.location.pathname.replace(/\/+$/, '') === routes.cart_url.replace(/\/+$/, '');
  }
  function refreshCartCount() {
    return fetch(routes.cart_url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCartCount(cart.item_count); })
      .catch(function () { /* leave the bubble as it was */ });
  }

  /* ---------- AJAX add to cart ---------- */
  // One place to swap the button label and put it back afterwards.
  function flashButton(btn, html, ms, cls) {
    if (btn.getAttribute('data-flashing')) return;
    btn.setAttribute('data-flashing', '1');
    btn.setAttribute('data-original-html', btn.innerHTML);
    if (cls) btn.classList.add(cls);
    btn.innerHTML = html;
    setTimeout(function () {
      btn.innerHTML = btn.getAttribute('data-original-html') || '';
      btn.removeAttribute('data-original-html');
      btn.removeAttribute('data-flashing');
      if (cls) btn.classList.remove(cls);
    }, ms);
  }
  function flashAdded(btn) { flashButton(btn, strings.added || 'Added ✓', 1600, 'added'); }
  function flashError(btn) { flashButton(btn, strings.error || 'Something went wrong', 2800); }
  function flashLimit(btn, available) {
    var tpl = strings.stock_limit || 'Sorry, we only have %%COUNT%% available';
    flashButton(btn, tpl.replace('%%COUNT%%', available), 3200, 'at-limit');
  }

  // Shopify answers an over-order with a 422, but it is not a failure: it still
  // adds everything that was in stock. Work out the real number so we can say so
  // rather than showing a scary generic error.
  function stockLimitFrom(err, cart, variantId) {
    var text = (err && (err.description || err.message)) || '';
    if (!/availability|maximum quantity/i.test(text)) return null;
    // After a clamped add the cart holds exactly what was available, so the
    // line quantity is the truest figure. Sum lines in case properties split it.
    var inCart = 0;
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].variant_id === variantId) inCart += items[i].quantity;
    }
    if (inCart > 0) return inCart;
    var m = text.match(/(\d+)/); // fall back to the number Shopify quoted
    return m ? parseInt(m[1], 10) : null;
  }

  function ajaxAdd(id, qty, btn, properties) {
    var item = { id: id, quantity: qty || 1 };
    if (properties) item.properties = properties;
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      if (r.ok) return null;
      return r.json().catch(function () { return {}; });
    }).then(function (err) {
      // Re-read the cart either way — a clamped add still changed it, so the
      // bubble must update even though the response was a 422.
      return fetch(routes.cart_url + '.js').then(function (r2) { return r2.json(); }).then(function (cart) {
        setCartCount(cart.item_count);
        if (btn) {
          if (!err) {
            flashAdded(btn);
          } else {
            var available = stockLimitFrom(err, cart, id);
            if (available !== null) flashLimit(btn, available);
            else flashError(btn);
          }
        }
        // That add may have taken the basket over the gift line, or back under it.
        return reconcileGift(cart).then(function (changed) {
          if (changed) return refreshCartCount();
        });
      });
    }).catch(function () {
      if (btn) flashError(btn);
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var props = null;
    var note = btn.getAttribute('data-preorder-note');
    if (note) props = { 'Pre-order': note };
    ajaxAdd(parseInt(btn.getAttribute('data-quick-add'), 10), 1, btn, props);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var id = parseInt(form.querySelector('[name="id"]').value, 10);
    var qtyEl = form.querySelector('[name="quantity"]');
    // Carry any line-item properties (e.g. the pre-order arrival date) to the cart
    var props = null;
    form.querySelectorAll('[name^="properties["]').forEach(function (input) {
      if (!input.value) return;
      var key = input.name.slice(11, -1);
      props = props || {};
      props[key] = input.value;
    });
    ajaxAdd(id, qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1, btn, props);
  });

  /* ---------- Sticky mobile buy bar proxies the main form ---------- */
  document.addEventListener('click', function (e) {
    var proxy = e.target.closest('[data-buybar-add]');
    if (!proxy || proxy.disabled) return;
    var form = document.querySelector('form[data-ajax-add]');
    if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  });

  /* ---------- Cart page: change quantities / remove ---------- */
  function cartChange(line, quantity) {
    fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return reconcileGift(cart); })
      .catch(function () { /* reload regardless — the server is the truth */ })
      .then(function () { window.location.reload(); });
  }
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-line-qty]');
    if (!input) return;
    cartChange(parseInt(input.getAttribute('data-cart-line-qty'), 10), Math.max(0, parseInt(input.value, 10) || 0));
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (!rm) return;
    e.preventDefault();
    cartChange(parseInt(rm.getAttribute('data-cart-remove'), 10), 0);
  });

  /* ---------- Collection filters: auto-submit on change ---------- */
  var filterForm = document.getElementById('CollectionFilters');
  if (filterForm) {
    filterForm.addEventListener('change', function (e) {
      if (e.target.matches('input[type="checkbox"], select')) filterForm.submit();
    });
    filterForm.querySelectorAll('.price-inputs input').forEach(function (inp) {
      inp.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') { ev.preventDefault(); filterForm.submit(); } });
      inp.addEventListener('blur', function () { if (inp.value !== inp.defaultValue) filterForm.submit(); });
    });
    // Close other dropdowns when one opens; close on outside click
    var drops = filterForm.querySelectorAll('details.f-drop');
    drops.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) drops.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('details.f-drop')) drops.forEach(function (o) { o.open = false; });
    });
  }
  var sortSelect = document.querySelector('[data-sort-by]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ---------- Product gallery ---------- */
  (function () {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('.main-media');
    var items = gallery.querySelectorAll('.media-item');
    var thumbs = gallery.querySelectorAll('[data-thumb]');

    function stopMedia() {
      main.classList.remove('playing');
      items.forEach(function (it) {
        var v = it.querySelector('video');
        if (v) v.pause();
        // Unload YouTube/Vimeo embeds so they stop playing when switching media
        var frame = it.querySelector('iframe');
        if (frame) frame.parentNode.removeChild(frame);
      });
    }

    function activeItem() { return gallery.querySelector('.media-item.on'); }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        stopMedia();
        thumbs.forEach(function (o) { o.classList.remove('on'); });
        t.classList.add('on');
        var idx = t.getAttribute('data-thumb');
        items.forEach(function (it) { it.classList.toggle('on', it.getAttribute('data-media') === idx); });
        var item = activeItem();
        main.classList.toggle('on-video', !!(item && item.hasAttribute('data-video')));
      });
    });

    main.addEventListener('click', function (e) {
      var item = activeItem();
      if (!item || !item.hasAttribute('data-video')) return;

      var embed = item.getAttribute('data-embed');
      if (embed) {
        // External video: swap the poster for an autoplaying embed on first click
        if (item.querySelector('iframe')) return;
        var frame = document.createElement('iframe');
        frame.src = embed;
        frame.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
        frame.setAttribute('allowfullscreen', '');
        frame.setAttribute('title', document.title);
        item.appendChild(frame);
        main.classList.add('playing');
        return;
      }

      // Native video: let its own controls handle clicks on the element itself
      var video = item.querySelector('video');
      if (!video || e.target === video) return;
      if (video.paused) { video.play(); main.classList.add('playing'); }
      else { video.pause(); main.classList.remove('playing'); }
    });
  })();

  /* ---------- Product recommendations (Complete the show) ---------- */
  (function () {
    var holder = document.querySelector('[data-recommendations]');
    if (!holder) return;
    var url = holder.getAttribute('data-url');
    fetch(url).then(function (r) { return r.text(); }).then(function (text) {
      var doc = new DOMParser().parseFromString(text, 'text/html');
      var inner = doc.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim().length) holder.innerHTML = inner.innerHTML;
    }).catch(function () { /* leave fallback content in place */ });
  })();

  /* ---------- Settle the gift on arrival ---------- */
  // Catches baskets filled before the offer was switched on, and any other route
  // into the basket that does not pass through the handlers above.
  if (giftLive) {
    fetch(routes.cart_url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { return cart.item_count ? reconcileGift(cart) : false; })
      .then(function (changed) {
        if (!changed) return;
        if (onCartPage()) window.location.reload();
        else refreshCartCount();
      })
      .catch(function () { /* if the basket cannot be read, leave it alone */ });
  }

})();
